import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="top-navigation-drawer"
export default class extends Controller {
	static targets = ["drawer", "button"];

	connect() {
		this.open = false;
		document.addEventListener("top-navigation-drawer:open", this.closeWhenAnotherDrawerOpens);
		document.addEventListener("turbo:before-cache", this.closeWithoutFocus);
	}

	disconnect() {
		document.removeEventListener("top-navigation-drawer:open", this.closeWhenAnotherDrawerOpens);
		document.removeEventListener("turbo:before-cache", this.closeWithoutFocus);
		this.close({ restoreFocus: false });
	}

	openDrawer(event) {
		event.preventDefault();
		event.stopPropagation();

		if (this.open) {
			this.close({ restoreFocus: true });
			return;
		}

		document.dispatchEvent(new CustomEvent("top-navigation-drawer:open", { detail: { drawer: this.element } }));
		this.drawerTarget.hidden = false;
		this.drawerTarget.classList.add("z-40");
		this.buttonTarget.classList.add("text-carmesim-500");
		this.buttonTarget.setAttribute("aria-expanded", "true");
		this.open = true;
		// The phone search row: one tap on the magnifier and the field is ready to type in.
		this.drawerTarget.querySelector("input")?.focus();
		document.addEventListener("pointerdown", this.closeOnPointerDown);
		document.addEventListener("focusin", this.closeOnFocusIn);
		document.addEventListener("keydown", this.closeOnEscape);
	}

	closeDrawer(event) {
		if (event && this.drawerTarget.contains(event.target)) {
			return;
		}

		this.close({ restoreFocus: true });
	}

	close({ restoreFocus = false } = {}) {
		if (!this.open) {
			this.drawerTarget.hidden = true;
			this.buttonTarget.setAttribute("aria-expanded", "false");
			return;
		}

		this.drawerTarget.hidden = true;
		this.drawerTarget.classList.remove("z-40");
		this.buttonTarget.classList.remove("text-carmesim-500");
		this.buttonTarget.setAttribute("aria-expanded", "false");
		this.open = false;
		document.removeEventListener("pointerdown", this.closeOnPointerDown);
		document.removeEventListener("focusin", this.closeOnFocusIn);
		document.removeEventListener("keydown", this.closeOnEscape);

		if (restoreFocus) {
			this.buttonTarget.focus();
		}
	}

	closeWithoutFocus = () => {
		this.close({ restoreFocus: false });
	};

	closeWhenAnotherDrawerOpens = (event) => {
		if (event.detail?.drawer !== this.element) {
			this.close({ restoreFocus: false });
		}
	};

	closeOnPointerDown = (event) => {
		if (!this.element.contains(event.target)) {
			this.close({ restoreFocus: false });
		}
	};

	closeOnFocusIn = (event) => {
		if (!this.element.contains(event.target)) {
			this.close({ restoreFocus: false });
		}
	};

	closeOnEscape = (event) => {
		if (event.key === "Escape") {
			event.preventDefault();
			this.close({ restoreFocus: true });
		}
	};
}
